/**
 * Kad telefon sme da povuče izmenjenu turu sa servera.
 *
 * Dva uslova, i oba su bitna iz različitog razloga:
 *
 * 1. Server ima noviju verziju — inače nema šta da se povlači.
 * 2. Red za slanje je prazan — ekran prikazuje poteze čim ih vozač napravi,
 *    pre nego što odu na server. Da se tura preuzme dok red nije ispražnjen,
 *    ti potezi bi nestali sa ekrana. Nisu izgubljeni (red ih čuva), ali vozač
 *    to ne zna — video bi da mu se štikliranje „vratilo", i uradio ga opet.
 *
 * Kad reda nema, nema se šta izgubiti: server tada zna sve što i telefon.
 */
export function trebaPovuciTuru(
  verzijaUTelefonu: number | undefined,
  verzijaNaServeru: number | undefined,
  brojNeposlatih: number
): boolean {
  if (brojNeposlatih > 0) {
    return false;
  }

  // Starije kopije nemaju verziju. Neizmenjena tura jeste prva verzija, pa se
  // prazno čita kao 1 — a ne kao nula, jer bi tada svaka tura izgledala
  // izmenjeno i telefon bi je povlačio u krug.
  return (verzijaNaServeru ?? 1) > (verzijaUTelefonu ?? 1);
}
